import React, { Component } from "react";

class warning extends Component {
  render() {
    return "";
  }
}
export default warning;

/* 
<div className="Warning">
        <br></br>
        <text style={{ textAlign: "center" }}>
        Warning Text Goes Here
        </text>
      </div>
    );
*/
